module.exports = __webpack_public_path__ + "img/airpa_10.1216552b.svg";